import React, { useState } from 'react';
import styles from './CalcAssessment.module.scss';
import clsx from 'clsx';
import { CALC_TYPES } from 'utils/calculatorUtils';
import RenameInput from '../ReportRename/ReportRename';
import { deleteResult, renameResult } from 'api/calc/endpoints/calc';
import { useNavigate } from 'react-router';
import { URL_SCORE_DETAILS } from 'constants/calculatorsPage';

const CalcAssessment = ({ assessment, targetWidth, updateAssessmentName, setErrorText }) => {
  const [editId, setEditId] = useState(null);
  const [loadingRename, setLoadingRename] = useState(false);
  const navigate = useNavigate();

  const getSubType = () => {
    switch (assessment.type) {
      case CALC_TYPES.CARBON:
        return 'Annual';
      case CALC_TYPES.PROJECT:
        return 'Project';
      default:
        return null;
    }
  };

  const getReportPeriod = () => {
    switch (assessment.type) {
      case CALC_TYPES.CARBON:
        return assessment?.periodReportDate?.getFullYear();
      case CALC_TYPES.PROJECT:
        return `${assessment?.periodReportDate?.toLocaleDateString()}-${assessment?.periodReportDateEnd?.toLocaleDateString()}`;
      default:
        return null;
    }
  };

  const onRenameResult = async (e) => {
    const rawValue = e?.target?.value;
    if (!rawValue || rawValue.trim() === '') return;

    const { value } = e.target;

    setEditId(null);
    setTimeout(() => {
      setLoadingRename(true);

      renameResult({ id: assessment.id, name: value })
        .then(() => {
          updateAssessmentName(assessment.id, value);
        })
        .catch((err) => {
          console.log(err);
          setErrorText('Error renaming draft');
        })
        .finally(() => {
          setLoadingRename(false);
        });
    }, 0);
  };

  return (
    <>
      <div
        key={assessment.id}
        className={clsx(styles.rowWrapper, targetWidth < 740 && styles.shortFormat)}
        onClick={() =>
          !editId ? navigate(`${URL_SCORE_DETAILS}/${assessment.type}/${assessment.id}`) : null
        }
      >
        <div className={styles.summary}>
          <div className={styles.draftName}>
            <RenameInput
              id={assessment.id}
              name={assessment.name}
              onEditClick={() => setEditId(editId === assessment.id ? null : assessment.id)}
              onEditFinish={onRenameResult}
              isEditing={editId === assessment.id}
              isLoading={loadingRename}
            />
            {getSubType() && <div className={styles.dataValue}>{getSubType()}</div>}
          </div>
          <div className={clsx(styles.horizontal, styles.info)}>
            <div className={clsx(styles.dataBlock, styles.vertical)} style={{ minWidth: '168px' }}>
              <div className={clsx(styles.container, styles.horizontal)}>
                <p className={styles.dataName}>Edited:</p>
                <p className={styles.dataValue}>
                  {assessment?.updatedAt?.toLocaleDateString() ?? ''}
                </p>
              </div>
              <div className={clsx(styles.container, styles.horizontal)}>
                <p className={styles.dataName}>Created:</p>
                <p className={styles.dataValue}>
                  {assessment?.createdAt?.toLocaleDateString() ?? ''}
                </p>
              </div>
            </div>
            <div
              className={clsx(styles.dataBlock, styles.vertical, styles.period)}
              style={{ minWidth: '168px' }}
            >
              <p className={clsx(styles.dataName, assessment?.periodReportDate ?? styles.gray)}>
                Reporting period:
              </p>
              {assessment?.periodReportDate && (
                <p className={styles.dataValue}>{getReportPeriod()}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CalcAssessment;
